<script lang="ts">
  /**
   * Imports
   * ---------------------------------------------------------------------------
   */

  import { twJoin } from "tailwind-merge";
  /**
   * Props
   * ---------------------------------------------------------------------------
   */

  /** href - if set, then the entire Card is a link to this URL */
  export let href: undefined | string = undefined;

  /** if true, then this Card is highlighted as being focused */
  export let isFocused: boolean = false;

  /**
   * If disabled, then this Card (including its CTA buttons) cannot
   * be interacted with and does not receive pointer events.
   */
  export let isDisabled: boolean = false;

  /** orientation of the card */
  export let orientation: "portrait" | "landscape" | "flexible" = "portrait";

  /** pass any custom class to the topmost element */
  export let { class: classProp = "" } = $$props;

  export let featuredImageBackground: string | undefined = undefined;

  /**
   * If set, then this Card will zoom in when the mouse is hovered over it.
   */
  export let hoverBehavior: "zoom-box" | "zoom-image" | "none" = "zoom-box";

  /**
   * Data / State
   * ---------------------------------------------------------------------------
   */

  let isZoomed = false;

  /**
   * Functions
   * ---------------------------------------------------------------------------
   */

  function zoomIn(e: any) {
    isZoomed = true;
  }

  function zoomOut(e: any) {
    isZoomed = false;
  }
  const orientationClasses = {
    portrait: "max-w-[450px]",
    landscape: "w-full",
    flexible: "md:min-h-[400px] h-full",
  };

  $: zoomBox = hoverBehavior === "zoom-box" && isZoomed;
  $: zoomImage = hoverBehavior === "zoom-image" && isZoomed;
</script>

<!-- Template ----------------------------------------------------------------->

<a
  on:mouseleave={zoomOut}
  on:mouseenter={zoomIn}
  {href}
  class={twJoin(
    "@container bg-n900 relative rounded-3xl overflow-hidden w-full",
    "flex flex-col",
    "align-start relative m-0",
    "transition-transform duration-300", // for zoom transition
    "rounded-2xl", // standard
    "md:rounded-3xl", // medium
    isFocused && "border-p100 border-solid border",
    isDisabled && "cursor-auto pointer-events-none",
    zoomBox && "md:scale-105",
    classProp,
    orientationClasses[orientation],
  )}
>
  {#if !!featuredImageBackground}
    <img
      src={`${featuredImageBackground}`}
      alt=""
      class={twJoin(
        "transition-transform duration-300 absolute top-0 left-0 w-full h-full object-cover",
        zoomImage && "md:scale-110",
      )}
    />
  {/if}
  <slot />
</a>
